module.exports = __webpack_public_path__ + "static/media/routeSellers.3daea132.png";